import type { ITreeNode } from '@platform/core/types';
import type { IOrderedNode } from './IOrderedNode';

/**
 * Обхід дерева напрямів/ітерацій у глибину: корені (без батька або з невідомим батьком), далі діти кожного вузла за sort і назвою;
 * глибина — від кореня. Вузли, недосяжні з коренів (цикл у даних), додаються в кінці з глибиною за кількістю сегментів шляху.
 */
export function orderTree(nodes: ITreeNode[]): IOrderedNode[] {
  const ids = new Set(nodes.map((n) => n.id));
  const kids = new Map<string, ITreeNode[]>();
  const roots: ITreeNode[] = [];
  nodes.forEach((n) => {
    if (n.parentId && ids.has(n.parentId)) kids.set(n.parentId, [...(kids.get(n.parentId) ?? []), n]);
    else roots.push(n);
  });
  const sort = (list: ITreeNode[]) => [...list].sort((a, b) => a.sort - b.sort || a.name.localeCompare(b.name));
  const out: IOrderedNode[] = [];
  const seen = new Set<string>();
  const walk = (n: ITreeNode, depth: number) => {
    if (seen.has(n.id)) return;
    seen.add(n.id); out.push({ node: n, depth });
    sort(kids.get(n.id) ?? []).forEach((c) => walk(c, depth + 1));
  };
  sort(roots).forEach((r) => walk(r, 0));
  nodes.filter((n) => !seen.has(n.id)).forEach((n) => out.push({ node: n, depth: Math.max(0, n.path.split('.').length - 1) }));
  return out;
}
